import "core-js/modules/es6.reflect.construct.js";
import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.object.get-own-property-descriptor.js";
import "core-js/modules/es7.object.get-own-property-descriptors.js";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import "core-js/modules/es6.array.sort.js";
import "core-js/modules/es6.array.slice.js";
import "core-js/modules/es6.array.map.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.function.name.js";

/* eslint jsx-a11y/no-autofocus: 0 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Trigger from 'rc-trigger';
import moment from 'moment';
import Input from './Input';
import Panel from './Panel';
import placements from './placements';

function noop() {}

function refFn(field, component) {
  this[field] = component;
} // 增加的计算时间项的方法 added by: gx


function generateOptions(length, disabledOptions, hideDisabledOptions) {
  var step = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
  // 生成选项数组
  var arr = [];

  for (var value = 0; value < length; value += step) {
    if (!disabledOptions || disabledOptions.indexOf(value) < 0 || !hideDisabledOptions) {
      arr.push(value);
    }
  }

  return arr;
}

function toNearestValidTime(time, hourOptions, minuteOptions, secondOptions) {
  // 至最近的合法时间
  var hour = hourOptions.slice().sort(function (a, b) {
    return Math.abs(time.hour() - a) - Math.abs(time.hour() - b);
  })[0];
  var minute = minuteOptions.slice().sort(function (a, b) {
    return Math.abs(time.minute() - a) - Math.abs(time.minute() - b);
  })[0];
  var second = secondOptions.slice().sort(function (a, b) {
    return Math.abs(time.second() - a) - Math.abs(time.second() - b);
  })[0];
  return moment("".concat(hour, ":").concat(minute, ":").concat(second), 'HH:mm:ss');
}

var Picker = /*#__PURE__*/function (_Component) {
  _inherits(Picker, _Component);

  var _super = _createSuper(Picker);

  function Picker(props) {
    var _this;

    _classCallCheck(this, Picker);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "onPanelChange", function (value) {
      _this.setValue(value);
    });

    _defineProperty(_assertThisInitialized(_this), "onAmPmChange", function (ampm) {
      var onAmPmChange = _this.props.onAmPmChange;
      onAmPmChange(ampm);
    });

    _defineProperty(_assertThisInitialized(_this), "onClear", function (event) {
      event.stopPropagation();

      _this.setValue(null);

      _this.setOpen(false);
    });

    _defineProperty(_assertThisInitialized(_this), "onVisibleChange", function (open) {
      _this.setOpen(open);
    });

    _defineProperty(_assertThisInitialized(_this), "onEsc", function () {
      _this.setOpen(false);

      _this.focus();
    });

    _defineProperty(_assertThisInitialized(_this), "onKeyDown", function (e) {
      if (e.keyCode === 40) {
        _this.setOpen(true);
      }

      _this.props.onKeyDown && _this.props.onKeyDown(e);
    });

    _defineProperty(_assertThisInitialized(_this), "disabledHours", function () {
      var _this$props = _this.props,
          use12Hours = _this$props.use12Hours,
          disabledHours = _this$props.disabledHours;
      var disabledOptions = disabledHours();

      if (use12Hours && Array.isArray(disabledOptions)) {
        if (_this.isAM()) {
          disabledOptions = disabledOptions.filter(function (h) {
            return h < 12;
          }).map(function (h) {
            return h === 0 ? 12 : h;
          });
        } else {
          disabledOptions = disabledOptions.map(function (h) {
            return h === 12 ? 12 : h - 12;
          });
        }
      }

      return disabledOptions;
    });

    _defineProperty(_assertThisInitialized(_this), "handleInputWidthChange", function (width) {
      _this.setState({
        inputWidth: width
      });
    });

    _this.saveInputRef = refFn.bind(_assertThisInitialized(_this), 'picker');
    _this.savePanelRef = refFn.bind(_assertThisInitialized(_this), 'panelInstance');

    var defaultOpen = props.defaultOpen,
        defaultValue = props.defaultValue,
        _props$open = props.open,
        _open = _props$open === void 0 ? defaultOpen : _props$open,
        _props$value = props.value,
        _value = _props$value === void 0 ? defaultValue : _props$value;

    _this.state = {
      open: _open,
      value: _value
    };
    return _this;
  }

  _createClass(Picker, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      var value = nextProps.value,
          open = nextProps.open;

      if ('value' in nextProps) {
        this.setState({
          value: value
        });
      }

      if (open !== undefined) {
        this.setState({
          open: open
        });
      }
    }
  }, {
    key: "setValue",
    value: function setValue(value) {
      var onChange = this.props.onChange;

      if (!('value' in this.props)) {
        this.setState({
          value: value
        });
      }

      onChange(value);
    }
  }, {
    key: "getFormat",
    value: function getFormat() {
      var _this$props2 = this.props,
          format = _this$props2.format,
          showHour = _this$props2.showHour,
          showMinute = _this$props2.showMinute,
          showSecond = _this$props2.showSecond,
          use12Hours = _this$props2.use12Hours;

      if (format) {
        return format;
      }

      if (use12Hours) {
        var fmtString = [showHour ? 'h' : '', showMinute ? 'mm' : '', showSecond ? 'ss' : ''].filter(function (item) {
          return !!item;
        }).join(':');
        return fmtString.concat(' a');
      }

      return [showHour ? 'HH' : '', showMinute ? 'mm' : '', showSecond ? 'ss' : ''].filter(function (item) {
        return !!item;
      }).join(':');
    }
  }, {
    key: "getPanelElement",
    value: function getPanelElement() {
      var _this$props3 = this.props,
          prefixCls = _this$props3.prefixCls,
          placeholder = _this$props3.placeholder,
          disabledHours = _this$props3.disabledHours,
          disabledMinutes = _this$props3.disabledMinutes,
          disabledSeconds = _this$props3.disabledSeconds,
          hideDisabledOptions = _this$props3.hideDisabledOptions,
          inputReadOnly = _this$props3.inputReadOnly,
          allowEmpty = _this$props3.allowEmpty,
          showHour = _this$props3.showHour,
          showMinute = _this$props3.showMinute,
          showSecond = _this$props3.showSecond,
          defaultOpenValue = _this$props3.defaultOpenValue,
          clearText = _this$props3.clearText,
          renderExtraFooter = _this$props3.renderExtraFooter,
          use12Hours = _this$props3.use12Hours,
          focusOnOpen = _this$props3.focusOnOpen,
          onKeyDown = _this$props3.onKeyDown,
          hourStep = _this$props3.hourStep,
          minuteStep = _this$props3.minuteStep,
          secondStep = _this$props3.secondStep,
          clearIcon = _this$props3.clearIcon;
      var _this$state = this.state,
          value = _this$state.value,
          inputWidth = _this$state.inputWidth;
      return /*#__PURE__*/React.createElement(Panel, {
        clearText: clearText,
        prefixCls: "".concat(prefixCls, "-panel"),
        ref: this.savePanelRef,
        value: value,
        inputReadOnly: inputReadOnly,
        onChange: this.onPanelChange,
        onAmPmChange: this.onAmPmChange,
        defaultOpenValue: defaultOpenValue,
        showHour: showHour,
        showMinute: showMinute,
        showSecond: showSecond,
        onEsc: this.onEsc,
        allowEmpty: allowEmpty,
        format: this.getFormat(),
        placeholder: placeholder,
        disabledHours: disabledHours,
        disabledMinutes: disabledMinutes,
        disabledSeconds: disabledSeconds,
        hideDisabledOptions: hideDisabledOptions,
        use12Hours: use12Hours,
        hourStep: hourStep,
        minuteStep: minuteStep,
        secondStep: secondStep,
        addon: renderExtraFooter,
        focusOnOpen: focusOnOpen,
        onKeyDown: onKeyDown,
        clearIcon: clearIcon,
        width: inputWidth
      });
    }
  }, {
    key: "getPopupClassName",
    value: function getPopupClassName() {
      var _this$props4 = this.props,
          showHour = _this$props4.showHour,
          showMinute = _this$props4.showMinute,
          showSecond = _this$props4.showSecond,
          use12Hours = _this$props4.use12Hours,
          prefixCls = _this$props4.prefixCls,
          popupClassName = _this$props4.popupClassName;
      var className = popupClassName; // Keep it for old compatibility

      if ((!showHour || !showMinute || !showSecond) && !use12Hours) {
        className += " ".concat(prefixCls, "-panel-narrow");
      }

      var selectColumnCount = 0;

      if (showHour) {
        selectColumnCount += 1;
      }

      if (showMinute) {
        selectColumnCount += 1;
      }

      if (showSecond) {
        selectColumnCount += 1;
      }

      if (use12Hours) {
        selectColumnCount += 1;
      }

      className += " ".concat(prefixCls, "-panel-column-").concat(selectColumnCount);
      return className;
    }
  }, {
    key: "setOpen",
    value: function setOpen(open) {
      var _this$props5 = this.props,
          onOpen = _this$props5.onOpen,
          onClose = _this$props5.onClose,
          onOpenChange = _this$props5.onOpenChange;
      var currentOpen = this.state.open;

      if (currentOpen !== open) {
        if (!('open' in this.props)) {
          this.setState({
            open: open
          });
        }

        if (onOpenChange) onOpenChange({
          open: open
        });

        if (open) {
          onOpen({
            open: open
          });
        } else {
          onClose({
            open: open
          });
        }
      }
    }
  }, {
    key: "focus",
    value: function focus() {
      this.picker.focus();
    }
  }, {
    key: "blur",
    value: function blur() {
      this.picker.blur();
    }
  }, {
    key: "renderClearButton",
    value: function renderClearButton() {
      var _this2 = this;

      var value = this.state.value;
      var _this$props6 = this.props,
          prefixCls = _this$props6.prefixCls,
          allowEmpty = _this$props6.allowEmpty,
          clearIcon = _this$props6.clearIcon,
          clearText = _this$props6.clearText;

      if (!allowEmpty || !value) {
        return null;
      }

      if ( /*#__PURE__*/React.isValidElement(clearIcon)) {
        var _ref = clearIcon.props || {},
            _onClick = _ref.onClick;

        return /*#__PURE__*/React.cloneElement(clearIcon, {
          title: clearText,
          onClick: function onClick() {
            if (_onClick) _onClick.apply(void 0, arguments);

            _this2.onClear.apply(_this2, arguments);
          }
        });
      }

      return /*#__PURE__*/React.createElement("a", {
        role: "button",
        className: "".concat(prefixCls, "-clear"),
        title: clearText,
        onClick: this.onClear,
        tabIndex: 0
      }, clearIcon || /*#__PURE__*/React.createElement("i", {
        className: "".concat(prefixCls, "-clear-icon")
      }));
    } // 计算不可用小时选项 added by: gx

  }, {
    key: "render",
    value: function render() {
      var _this$props7 = this.props,
          prefixCls = _this$props7.prefixCls,
          placeholder = _this$props7.placeholder,
          placement = _this$props7.placement,
          align = _this$props7.align,
          allowEmpty = _this$props7.allowEmpty,
          id = _this$props7.id,
          disabled = _this$props7.disabled,
          transitionName = _this$props7.transitionName,
          style = _this$props7.style,
          className = _this$props7.className,
          getPopupContainer = _this$props7.getPopupContainer,
          name = _this$props7.name,
          autoComplete = _this$props7.autoComplete,
          onFocus = _this$props7.onFocus,
          onBlur = _this$props7.onBlur,
          autoFocus = _this$props7.autoFocus,
          inputReadOnly = _this$props7.inputReadOnly,
          inputIcon = _this$props7.inputIcon,
          popupStyle = _this$props7.popupStyle,
          allowClear = _this$props7.allowClear,
          disabledHours = _this$props7.disabledHours,
          disabledMinutes = _this$props7.disabledMinutes,
          disabledSeconds = _this$props7.disabledSeconds,
          focusOnOpen = _this$props7.focusOnOpen,
          clearIcon = _this$props7.clearIcon,
          hideDisabledOptions = _this$props7.hideDisabledOptions,
          hourStep = _this$props7.hourStep,
          minuteStep = _this$props7.minuteStep,
          secondStep = _this$props7.secondStep,
          defaultOpenValue = _this$props7.defaultOpenValue,
          clearText = _this$props7.clearText,
          onEsc = _this$props7.onEsc; // 新增一些传给Input组件的属性 added by: gx

      var _this$state2 = this.state,
          open = _this$state2.open,
          value = _this$state2.value;
      var popupClassName = this.getPopupClassName(); // 将之前Header里的处理逻辑放到TimePicker中 added by: gx

      var disabledHourOptions = this.disabledHours();
      var disabledMinuteOptions = disabledMinutes(value ? value.hour() : null);
      var disabledSecondOptions = disabledSeconds(value ? value.hour() : null, value ? value.minute() : null);
      var hourOptions = generateOptions(24, disabledHourOptions, hideDisabledOptions, hourStep);
      var minuteOptions = generateOptions(60, disabledMinuteOptions, hideDisabledOptions, minuteStep);
      var secondOptions = generateOptions(60, disabledSecondOptions, hideDisabledOptions, secondStep);
      var validDefaultOpenValue = toNearestValidTime(defaultOpenValue, hourOptions, minuteOptions, secondOptions);
      return /*#__PURE__*/React.createElement(Trigger, {
        prefixCls: "".concat(prefixCls, "-panel"),
        popupClassName: popupClassName,
        popupStyle: _objectSpread({}, popupStyle),
        popup: this.getPanelElement(),
        popupAlign: align,
        builtinPlacements: placements,
        popupPlacement: placement,
        action: disabled ? [] : ['click'],
        destroyPopupOnHide: true,
        getPopupContainer: getPopupContainer,
        popupTransitionName: transitionName,
        popupVisible: open,
        onPopupVisibleChange: this.onVisibleChange
      }, /*#__PURE__*/React.createElement("span", {
        className: "".concat(prefixCls, " ").concat(className),
        style: style
      }, /*#__PURE__*/React.createElement(Input, {
        prefixCls: prefixCls,
        onFocus: onFocus,
        onBlur: onBlur,
        format: this.getFormat(),
        autoFocus: autoFocus,
        onChange: this.onPanelChange,
        autoComplete: autoComplete,
        disabled: disabled,
        onKeyDown: this.onKeyDown,
        name: name,
        placeholder: placeholder,
        id: id,
        readOnly: !!inputReadOnly,
        ref: this.saveInputRef,
        value: value && value.format(this.getFormat()) || '',
        clearText: clearText,
        defaultOpenValue: validDefaultOpenValue // currentSelectPanel={currentSelectPanel}
        ,
        onEsc: onEsc,
        hourOptions: hourOptions,
        minuteOptions: minuteOptions,
        secondOptions: secondOptions,
        disabledHours: this.disabledHours,
        disabledMinutes: disabledMinutes,
        disabledSeconds: disabledSeconds,
        allowEmpty: allowEmpty,
        focusOnOpen: focusOnOpen,
        clearIcon: clearIcon,
        handleInputWidthChange: this.handleInputWidthChange
      }), inputIcon || /*#__PURE__*/React.createElement("span", {
        className: "".concat(prefixCls, "-icon")
      }), allowClear && !disabled && this.renderClearButton()));
    }
  }]);

  return Picker;
}(Component);

_defineProperty(Picker, "propTypes", {
  prefixCls: PropTypes.string,
  clearText: PropTypes.string,
  value: PropTypes.object,
  defaultOpenValue: PropTypes.object,
  inputReadOnly: PropTypes.bool,
  disabled: PropTypes.bool,
  allowEmpty: PropTypes.bool,
  defaultValue: PropTypes.object,
  open: PropTypes.bool,
  defaultOpen: PropTypes.bool,
  align: PropTypes.object,
  placement: PropTypes.any,
  transitionName: PropTypes.string,
  getPopupContainer: PropTypes.func,
  placeholder: PropTypes.string,
  format: PropTypes.string,
  showHour: PropTypes.bool,
  showMinute: PropTypes.bool,
  showSecond: PropTypes.bool,
  style: PropTypes.object,
  className: PropTypes.string,
  popupClassName: PropTypes.string,
  popupStyle: PropTypes.object,
  disabledHours: PropTypes.func,
  disabledMinutes: PropTypes.func,
  disabledSeconds: PropTypes.func,
  hideDisabledOptions: PropTypes.bool,
  onChange: PropTypes.func,
  onAmPmChange: PropTypes.func,
  onOpen: PropTypes.func,
  onClose: PropTypes.func,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  renderExtraFooter: PropTypes.func,
  name: PropTypes.string,
  autoComplete: PropTypes.string,
  use12Hours: PropTypes.bool,
  hourStep: PropTypes.number,
  minuteStep: PropTypes.number,
  secondStep: PropTypes.number,
  focusOnOpen: PropTypes.bool,
  onKeyDown: PropTypes.func,
  autoFocus: PropTypes.bool,
  id: PropTypes.string,
  inputIcon: PropTypes.node,
  clearIcon: PropTypes.node
});

_defineProperty(Picker, "defaultProps", {
  clearText: 'clear',
  prefixCls: 'rc-time-picker',
  defaultOpen: false,
  inputReadOnly: false,
  style: {},
  className: '',
  popupClassName: '',
  popupStyle: {},
  id: '',
  align: {},
  defaultOpenValue: moment(),
  allowEmpty: true,
  showHour: true,
  showMinute: true,
  showSecond: true,
  disabledHours: noop,
  disabledMinutes: noop,
  disabledSeconds: noop,
  hideDisabledOptions: false,
  placement: 'bottomLeft',
  onChange: noop,
  onAmPmChange: noop,
  onOpen: noop,
  onClose: noop,
  onOpenChange: noop,
  onFocus: noop,
  onBlur: noop,
  renderExtraFooter: noop,
  use12Hours: false,
  focusOnOpen: false,
  onKeyDown: noop,
  allowClear: true,
  inputWidth: 0
});

export { Picker as default };


// WEBPACK FOOTER //
// ./~/@tinper/next-ui/lib/wui-timepicker/src/rc/TimePicker.js